import React, { useState, useEffect, useMemo } from "react";
import ActivityDisplay from "./ActivityDisplay";
import { useListDevicesQuery } from "../../actions/devicesInQuery";
import { useDetections, useTrapsiteIds } from "../../hooks/useAppAlerts";
import { Flex } from "antd";
import "./index.css";

type Props = {};

const Index: React.FC<Props> = () => {
  const { selectedTrapSiteId } = useTrapsiteIds();
  const { data: devices, isLoading: devicesLoading } = useListDevicesQuery();
  const [onlineDevices, setOnlineDevices] = useState(0);

  const includedDevices = useMemo(() => {
    if (selectedTrapSiteId) {
      return devices?.items?.filter(
        (d) => d.trap_site_id === selectedTrapSiteId,
      );
    }
    return devices?.items;
  }, [devices, selectedTrapSiteId]);

  useEffect(() => {
    const onlineCount =
      includedDevices?.filter((d) => d.status === "online").length || 0;
    setOnlineDevices(onlineCount);
  }, [includedDevices]);

  const { data: detectionData, isLoading: isDetectionLoading } = useDetections({
    page: 0,
    pageSize: 1,
    invasive: false,
  });

  const totalMosquitoDetections = detectionData?.count || 0;

  const { data: invasiveAlertsData, isLoading: isInvasiveAlertsLoading } =
    useDetections({
      page: 0,
      pageSize: 1,
      invasive: true,
    });

  const totalInvasiveMosquitoDetections = invasiveAlertsData?.count || 0;

  return (
    <Flex gap="1.5rem" className="w-full">
      <Flex flex={1}>
        <ActivityDisplay
          label="Invasive mosquito"
          sublabel="detections"
          variant="primary"
          value={totalInvasiveMosquitoDetections}
          loading={isInvasiveAlertsLoading}
        />
      </Flex>
      <Flex flex={1}>
        <ActivityDisplay
          label="Total mosquito"
          sublabel="detections"
          variant="primary"
          value={totalMosquitoDetections}
          loading={isDetectionLoading}
        />
      </Flex>
      <Flex flex={1}>
        <ActivityDisplay
          label="Traps online "
          sublabel={`(of ${includedDevices?.length || 0})`}
          variant="primary"
          value={onlineDevices}
          loading={devicesLoading}
        />
      </Flex>
    </Flex>
  );
};

export default Index;
